"use client";

import { logoSmall } from "@/utils/image";
import Image from "next/image";
import Link from "next/link";
import { Col, Row } from "react-bootstrap";
import { FiCheckCircle, FiLock, FiShield, FiUsers } from "react-icons/fi";

const HowItWorks = () => {
  return (
    <div className="py-5">
      <Link href="/login" className="d-flex justify-content-center mb-4">
        <Image src={logoSmall} alt="logo" />
      </Link>

      <div className="dashOuter p-4 p-md-5" style={{ maxWidth: "800px" }}>
        <div className="text-center mb-5">
          <h2 className="heading36 fw-bold mb-2">How It Works</h2>
          <p
            className="black60"
            style={{ maxWidth: "600px", margin: "0 auto" }}
          >
            Understand how Circle-of-Trust™ and Tokenized actions secure your
            onboarding and matching experience.
          </p>
        </div>

        <Row className="gy-4">
          {/* Circle-of-Trust */}
          <Col md={12}>
            <div
              className="p-4 rounded-4 d-flex align-items-start gap-3"
              style={{
                background: "rgba(194, 136, 64, 0.05)",
                border: "1px solid rgba(194, 136, 64, 0.15)",
              }}
            >
              <div
                className="p-3 rounded-3"
                style={{
                  background: "rgba(194, 136, 64, 0.1)",
                  color: "#c28840",
                }}
              >
                <FiShield size={32} />
              </div>
              <div>
                <h4
                  className="fw-bold mb-2 d-flex align-items-center gap-2"
                  style={{ color: "#c28840" }}
                >
                  Circle-of-Trust™
                </h4>
                <p className="mb-0 text-secondary">
                  Our platform acts as a secure layer where member identities
                  and interactions are vetted. By inviting people you trust to
                  your circle, you guarantee safety and secure, honest profile
                  validation.
                </p>
              </div>
            </div>
          </Col>

          {/* Tokenized Actions */}
          <Col md={12}>
            <div
              className="p-4 rounded-4 d-flex align-items-start gap-3"
              style={{
                background: "rgba(5, 150, 105, 0.05)",
                border: "1px solid rgba(5, 150, 105, 0.15)",
              }}
            >
              <div
                className="p-3 rounded-3"
                style={{
                  background: "rgba(5, 150, 105, 0.1)",
                  color: "var(--green)",
                }}
              >
                <FiLock size={32} />
              </div>
              <div>
                <h4
                  className="fw-bold mb-2 d-flex align-items-center gap-2"
                  style={{ color: "var(--green)" }}
                >
                  Tokenized Actions
                </h4>
                <p className="mb-0 text-secondary">
                  To eliminate account setup vulnerabilities and secure
                  platforms from bots, high-stakes onboardings and interactions
                  can utilize tokenized authentications or secure credential
                  verifiable logic. This acts as a digital guarantee that
                  requests are secure.
                </p>
              </div>
            </div>
          </Col>

          {/* Peer Validations */}
          <Col md={12}>
            <div
              className="p-4 rounded-4 d-flex align-items-start gap-3"
              style={{
                background: "rgba(59, 76, 202, 0.05)",
                border: "1px solid rgba(59, 76, 202, 0.15)",
              }}
            >
              <div
                className="p-3 rounded-3"
                style={{
                  background: "rgba(59, 76, 202, 0.1)",
                  color: "var(--blue)",
                }}
              >
                <FiUsers size={32} />
              </div>
              <div>
                <h4
                  className="fw-bold mb-2 d-flex align-items-center gap-2"
                  style={{ color: "var(--blue)" }}
                >
                  Peer Matching Validation
                </h4>
                <p className="mb-0 text-secondary">
                  Matches on the platform are peer-validated. Your mutual Circle
                  gets to authorize or decline requests creating verified
                  alignment and transparent interactions directly across the
                  ecosystem.
                </p>
              </div>
            </div>
          </Col>

          {/* Safe onboarding */}
          <Col md={12}>
            <div
              className="p-4 rounded-4 d-flex align-items-start gap-3"
              style={{
                background: "rgba(234, 37, 61, 0.05)",
                border: "1px solid rgba(234, 37, 61, 0.15)",
              }}
            >
              <div
                className="p-3 rounded-3"
                style={{
                  background: "rgba(234, 37, 61, 0.1)",
                  color: "var(--red)",
                }}
              >
                <FiCheckCircle size={32} />
              </div>
              <div>
                <h4
                  className="fw-bold mb-2 d-flex align-items-center gap-2"
                  style={{ color: "var(--red)" }}
                >
                  Dynamic Security Guards
                </h4>
                <p className="mb-0 text-secondary">
                  Automatic safeguards guarantee user data privacy during
                  critical onboard sessions. Standard data encryption modules
                  maintain complete isolation on connection routing preventing
                  spoofing actions.
                </p>
              </div>
            </div>
          </Col>
        </Row>

        <div className="text-center mt-5">
          <Link
            href="/signup"
            className="masterButton text-decoration-none d-inline-block px-5"
          >
            Start your Signup Validations
          </Link>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
